<div [formGroup]="filterForm" class="p-d-flex p-flex-row p-fluid">
  <kodit-filter-name
    class="flex-1-1"
    title="Filter radnih naloga"
  ></kodit-filter-name>

  <div class="flex-1-1 p-mr-4">
    <kodit-field fieldLabel="Broj" fieldLabelFor="broj">
      <kodit-text-input
        [formCtrl]="filterForm.controls.broj"
        formCtrlId="broj"
      ></kodit-text-input>
    </kodit-field>

    <kodit-field fieldLabel="Stranke" fieldLabelFor="stranke">
      <kodit-stranka-filter-multiselect
        [strankeFormArray]="strankeFormArray"
        ctrlPlaceholder="Stranke"
      ></kodit-stranka-filter-multiselect>
    </kodit-field>
  </div>

  <div class="flex-1-1 p-mr-4">
    <kodit-field fieldLabel="Vrsta radnog naloga" fieldLabelFor="vrste">
      <p-multiSelect
        id="vrste"
        [options]="vrsteOptions"
        formControlName="vrste"
        optionLabel="label"
        optionValue="value"
        placeholder="Sve vrste"
        appendTo="body"
      ></p-multiSelect>
    </kodit-field>

    <kodit-field fieldLabel="Status" fieldLabelFor="statusi">
      <p-multiSelect
        id="statusi"
        [options]="statusiOptions"
        formControlName="statusi"
        optionLabel="label"
        optionValue="value"
        placeholder="Svi statusi"
        appendTo="body"
      ></p-multiSelect>
    </kodit-field>
  </div>
</div>
